
import Carousel from 'react-bootstrap/Carousel';
import './Slider.css'

function Slider() {

   
    return (
    <>
        <section className="slider-container">
            <Carousel>
                <Carousel.Item interval={1500}>
                    <img src='/assets/images/slider1.webp' alt="sliderimages" className="image-container"></img>
                    <Carousel.Caption>
                       
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item interval={1500}>
                <img src='/assets/images/slider2.webp' alt="sliderimages" className="image-container"></img>
                    <Carousel.Caption>
                      
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item interval={1500}>
                <img src='/assets/images/slider3.webp' alt="sliderimages" className="image-container"></img>
                    <Carousel.Caption>
                       
                    </Carousel.Caption>
                </Carousel.Item>
            </Carousel>
        </section>
        <section className="product-mini-list-container">
            
        </section>
    </>
    );
}
export default Slider;